import script from "./CertificationsBadgeRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificationsBadgeRow.vue?vue&type=script&setup=true&lang=ts"

import "./CertificationsBadgeRow.vue?vue&type=style&index=0&id=4cf8846e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf8846e"]])

export default __exports__